import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=4322b4ca&scoped=true"
import script from "./UsersTable.vue?vue&type=script&lang=ts"
export * from "./UsersTable.vue?vue&type=script&lang=ts"
import style0 from "./UsersTable.vue?vue&type=style&index=0&id=4322b4ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4322b4ca",
  null
  
)

export default component.exports